import {
  SET_LOGIN_AUTH,
  SET_PATIENT_LOGIN_AUTH,
  SET_PATIENT_LOGOUT_AUTH,
  SET_LOGOUT_AUTH,
  INITIALIZE_APP,
  INITIALIZE_PATIENT_APP,
  PATIENT_INFO,
  BACK_NAVIGATION,
  VIEW_PDF,
  SIGNATURE_ACKNOWLEDGEMENT,
  PATIENT_PROCEDURE,
  TIME_STAMP,
  SET_TIME,
  USER_INFO,
  CLEAR_USER_INFO,
  UPDATE_NAVIAGTION_STATUS,
  DISABLE_BUTTONS,
  DISABLE_LINEAND_BUTTON,
  UPDATE_SURGERY_TIMES,
  UPDATE_SURGERY_TIMES_CLICKABLE,
  UPDATE_SURGERY_TIMES_ACTIVE,
  TIMER_ACKNOWLEDGEMENT,
  TIMER_MODALITY_ACKNOWLEDGEMENT,
  FLASH_ACKNOWLEDGEMENT,
  CLOSE_TIMESTAMP,
  CASES_COUNT_ACKNOWLEDGEMENT,
  SNACKBAR_ACKNOWLEDGEMENT,
  DATE_OF_SERVICE,
  PATIENT_DATE,
  ANESTHETIC_INFUSION_TIME,
  ATBR_PDF_ACKNOWLEDGEMENT,
  SELECTED_MODALITY,
  IMPERSONATE_USER_REFRESH_ACKNOWLEDGEMENT,
  IMPERSONATE_VIEW_ENABLED,
  TIMERMINSEC,
  PREVIEWATBRTIMESTAMP,
  UPDATEVITALSCOUNT,
  ENABLEMODALITIES,
  SELECTEDDATE,
  FETCH_USER_INFO,
  PATIENT_DETAILS,
  UPLOAD_DOCUMENTS,
  LOGIN_ERROR_MESSAGE,
  SET_OFFLINE_MODE,
  IS_PATIENT_DOCUMENT_DETAILS,
  SELECTED_DOUMENT_SUBMISSION_DETAILS_ID,
  IS_PATIENT_FORM_DETAILS,
  SET_ACTIVE_PARENT_TAB,
  CLEAR_PATIENT_FORM_DATA,
  SET_PATIENT_FORM_DATA,
  UPDATE_PATIENT_FORM_FIELD,
  PATIENT_FORMS_SUBMIT_REQUEST,
  PATIENT_FORMS_SUBMIT_CLEAR,
  IS_REFRESH_QUEUE_SUBMITTED_DOCUMENTS,
  IS_OPEN_UPLOAD_NEW_DOUMENT_MODAL,
  SHOW_OFFLINE_TOGGLE_BUTTON,
  SELECTED_DOUMENT_SUBMISSION_DETAILS_CASE_PID,
  SELECTED_ACTIVE_TAB,
  SET_GLOBAL_LOADING,
  TRIGGER_PATIENT_FORMS_REFRESH,
  SET_SELECTED_PREFETCH_CASES,
  IS_SURGEON_FORM_DETAILS,
  SELECTED_SURGEON_ID,
  SELECTED_SURGEON_NAME,
  SET_SURGEON_FORMS_DATA,
  CLEAR_SURGEON_FORMS_DATA,
  UPDATE_UNSAVED_ANESTHETIC_INFUSION,
  CLEAR_UNSAVED_ANESTHETIC_INFUSION
} from './Index';
//** Patient Forms API calls ** //
import { patientFormsValidationSchema } from '../../ValidationSchema/PatientFormsDetailsValidationSchema';

// For logging in the user
export const _login = (
  authToken: any,
  oauth: any,
  initialRoute: any
): any => async (dispatch: any) => {
  dispatch({ type: SET_LOGIN_AUTH, payload: { authToken, oauth, initialRoute } });
};

export const _patientLogin = (
  authToken: any,
  oauth: any,
  initialRoute: any
): any => async (dispatch: any) => {
  dispatch({ type: SET_PATIENT_LOGIN_AUTH, payload: { authToken, oauth, initialRoute } });
};

export const _loginError = (
  error: string
): any => async (dispatch: any) => {
  dispatch({ type: LOGIN_ERROR_MESSAGE, payload: { error } });
}

export const _patientInfo = (
  firstName: any,
  lastName: any,
  dos: any,
  surgeon: any,
  patientId: any
) => async (dispatch: any) => {
  dispatch({
    type: PATIENT_DETAILS,
    payload: { firstName, lastName, dos, surgeon, patientId }
  })
};

export const _uploadedDocuments = (
  files: string[]
) => async (dispatch: any) => {
  dispatch({
    type: UPLOAD_DOCUMENTS,
    payload: { files }
  })
}

export const _isPatientDocumentDetails = (
  isPatientDocumentDetails: boolean
): any => async (dispatch: any) => {
  dispatch({
    type: IS_PATIENT_DOCUMENT_DETAILS,
    payload: { isPatientDocumentDetails }
  });
};

export const _isRefreshQueueSubmittedDocuments = (
  isRefreshQueueSubmittedDocuments: boolean
): any => async (dispatch: any) => {
  dispatch({
    type: IS_REFRESH_QUEUE_SUBMITTED_DOCUMENTS,
    payload: { isRefreshQueueSubmittedDocuments }
  });
};

export const _isOpenUploadNewDocumentModal = (
  isOpenUploadNewDocumentModal: boolean
): any => async (dispatch: any) => {
  dispatch({
    type: IS_OPEN_UPLOAD_NEW_DOUMENT_MODAL,
    payload: { isOpenUploadNewDocumentModal }
  });
};

export const _impersonateUserRefreshAcknowledgement = (
  isImpersonateUserRefreshed: any
): any => async (dispatch: any) => {
  dispatch({
    type: IMPERSONATE_USER_REFRESH_ACKNOWLEDGEMENT,
    payload: { isImpersonateUserRefreshed }
  });
};

export const _impersonateViewEnabled = (
  isImpersonateViewEnabled: any,
  impersonateUserName: any
): any => async (dispatch: any) => {
  dispatch({
    type: IMPERSONATE_VIEW_ENABLED,
    payload: { isImpersonateViewEnabled, impersonateUserName }
  });
};

export const _logout = (): any => async (dispatch: any) => {
  dispatch({ type: SET_LOGOUT_AUTH, payload: {} });
};

export const _patientLogout = (): any => async (dispatch: any) => {
  dispatch({ type: SET_PATIENT_LOGOUT_AUTH, payload: {} });
};

export const _initApp = (config: any, data: any): any => async (
  dispatch: any
) => {
  dispatch({ type: INITIALIZE_APP, payload: { config, data } });
};

export const _initPatientApp = (config: any, data: any): any => async (
  dispatch: any
) => {
  dispatch({ type: INITIALIZE_PATIENT_APP, payload: { config, data } });
};

export const _headerInformation = (
  headerInfo: any,
  patientName: any,
  procedure: any,
  dob: any,
  userInfo: any,
  statusCards: any,
  id: any,
  route: any,
  backNavigationStatus: any,
  isPatientDocumentDetails: boolean
): any => async (dispatch: any) => {
  dispatch({
    type: PATIENT_INFO,
    payload: {
      headerInfo,
      patientName,
      procedure,
      dob,
      userInfo,
      statusCards,
      id,
      route,
      backNavigationStatus,
      isPatientDocumentDetails
    }
  });
};

export const _backNavigation = (
  headerInfo: any,
  patientName: any,
  procedure: any,
  dob: any,
  userInfo: any,
  statusCards: any,
  patientProcedure: any,
  backNavigationStatus: any
): any => async (dispatch: any) => {
  dispatch({
    type: BACK_NAVIGATION,
    payload: {
      headerInfo,
      patientName,
      procedure,
      dob,
      userInfo,
      statusCards,
      patientProcedure,
      backNavigationStatus
    }
  });
};

export const _viewPdf = (
  headerBar: any,
  viewPdf: any,
  route: any,
  patientProcedure: any
): any => async (dispatch: any) => {
  dispatch({
    type: VIEW_PDF,
    payload: { headerBar, viewPdf, route, patientProcedure }
  });
};

export const _atbrPdfAcknowledgement = (atbrPId: any): any => async (
  dispatch: any
) => {
  dispatch({ type: ATBR_PDF_ACKNOWLEDGEMENT, payload: { atbrPId } });
};

export const _signatureAcknowledgement = (headerBar: any): any => async (
  dispatch: any
) => {
  dispatch({ type: SIGNATURE_ACKNOWLEDGEMENT, payload: { headerBar } });
};

export const _timerAcknowledgement = (
  isTimerStarted: any,
  recordedVitalsCount: any,
  isNewTimerStarted: any,
  captureVitalsMinutes?: any,
  captureVitalsSecs?: any,
  isCaptureTimerStarted?: any
): any => async (dispatch: any) => {
  dispatch({
    type: TIMER_ACKNOWLEDGEMENT,
    payload: {
      isTimerStarted,
      recordedVitalsCount,
      isNewTimerStarted,
      captureVitalsMinutes,
      captureVitalsSecs,
      isCaptureTimerStarted
    }
  });
};

export const _timerModalityAcknowledgement = (
  modalityUpdated: any
): any => async (dispatch: any) => {
  dispatch({ type: TIMER_MODALITY_ACKNOWLEDGEMENT, payload: { modalityUpdated } });
};

export const _casesCountAcknowledgement = (
  toDayCasescount: any,
  assignedCasesCount: any,
  openedCasesCount: any
): any => async (dispatch: any) => {
  dispatch({
    type: CASES_COUNT_ACKNOWLEDGEMENT,
    payload: { toDayCasescount, assignedCasesCount, openedCasesCount }
  });
};

export const _flashAcknowledgement = (flashScreenEnabled: any): any => async (
  dispatch: any
) => {
  dispatch({ type: FLASH_ACKNOWLEDGEMENT, payload: { flashScreenEnabled } });
};

export const _snackbarAcknowledgement = (
  snackBarEnabled: any,
  snackBarMessage: any,
  snackBarType: any
): any => async (dispatch: any) => {
  dispatch({
    type: SNACKBAR_ACKNOWLEDGEMENT,
    payload: { snackBarEnabled, snackBarMessage, snackBarType }
  });
};

export const _patientProcedure = (patientProcedure: any): any => async (
  dispatch: any
) => {
  dispatch({ type: PATIENT_PROCEDURE, payload: { patientProcedure } });
};

export const _openTimeStamp = (
  timeStamp: any,
  headerType: any,
  timeStampLeft: any,
  selectedDate:any
): any => async (dispatch: any) => {
  dispatch({ type: TIME_STAMP, payload: { timeStamp, headerType, timeStampLeft, selectedDate } });
};

export const _setTimeStamp = (
  hours: any,
  minutes: any,
  timeStamp: any,
  date: any,
  month: any,
  year: any,
  hedaderTime:any
): any => async (dispatch: any) => {
  dispatch({
    type: SET_TIME,
    payload: { hours, minutes, timeStamp, date, month, year, hedaderTime }
  });
};

export const _userInformation = (
  userName: any,
  userId: any,
  webId: any,
  azureId: any,
  userType: any,
  actualUserId: any,
  actualWebId: any,
  actualToken: any,
  canImpersonate: any = false
): any => async (dispatch: any) => {
  dispatch({
    type: USER_INFO,
    payload: {
      userName,
      userId,
      webId,
      azureId,
      userType,
      actualUserId,
      actualWebId,
      actualToken,
      canImpersonate
    }
  });
};

export const _clearUserInformation = (): any => async (dispatch: any) => {
  dispatch({ type: CLEAR_USER_INFO, payload: {} });
};

export const _updatebackNavigatonStatus = (
  backNavigationStatus: any
): any => async (dispatch: any) => {
  dispatch({ type: UPDATE_NAVIAGTION_STATUS, payload: { backNavigationStatus } });
};

export const _disableButtons = (
  buttonsDisabled: any,
  alertDisabled: any
): any => async (dispatch: any) => {
  dispatch({ type: DISABLE_BUTTONS, payload: { buttonsDisabled, alertDisabled } });
};

export const _disableLineAndButton = (disableLineAndButton: any): any => async (
  dispatch: any
) => {
  dispatch({ type: DISABLE_LINEAND_BUTTON, payload: { disableLineAndButton } });
};

export const _updateSurgeryTimes = (
  headerConsultTime: any,
  headerInRoomTime: any,
  headerBaseLineTime: any,
  headerIncisionTime: any,
  headerCloseTime: any,
  headerOutOfRoomTime: any,
  headerNeuroCheckTime: any
): any => async (dispatch: any) => {
  dispatch({
    type: UPDATE_SURGERY_TIMES,
    payload: {
      headerConsultTime,
      headerInRoomTime,
      headerBaseLineTime,
      headerIncisionTime,
      headerCloseTime,
      headerOutOfRoomTime,
      headerNeuroCheckTime
    }
  });
};

export const _updateSurgeryTimesClickable = (
  consultClickable: any,
  inRoomClickable: any,
  baseLineClickable: any,
  incisionClickable: any,
  closeClickable: any,
  outOfRoomClickable: any,
  neuroCheckClickable: any
): any => async (dispatch: any) => {
  dispatch({
    type: UPDATE_SURGERY_TIMES_CLICKABLE,
    payload: {
      consultClickable,
      inRoomClickable,
      baseLineClickable,
      incisionClickable,
      closeClickable,
      outOfRoomClickable,
      neuroCheckClickable
    }
  });
};

export const _updateSurgeryTimesActive = (
  consultActive: any,
  inRoomActive: any,
  baseLineActive: any,
  incisionActive: any,
  closeActive: any,
  outOfRoomActive: any,
  neuroCheckActive: any
): any => async (dispatch: any) => {
  dispatch({
    type: UPDATE_SURGERY_TIMES_ACTIVE,
    payload: {
      consultActive,
      inRoomActive,
      baseLineActive,
      incisionActive,
      closeActive,
      outOfRoomActive,
      neuroCheckActive
    }
  });
};

export const _closeTimeStamp = (timeStamp: any): any => async (
  dispatch: any
) => {
  dispatch({ type: CLOSE_TIMESTAMP, payload: { timeStamp } });
};

export const _dateOfService = (dos: any): any => async (dispatch: any) => {
  dispatch({ type: DATE_OF_SERVICE, payload: { dos } });
};

export const _patientDate = (date: any, month: any, year: any): any => async (
  dispatch: any
) => {
  dispatch({ type: PATIENT_DATE, payload: { date, month, year } });
};

export const _anestheticInfusionTime = (
  anestheticInfusionTime: any
): any => async (dispatch: any) => {
  dispatch({ type: ANESTHETIC_INFUSION_TIME, payload: { anestheticInfusionTime } });
};

export const _selectedModalityId = (selectedModalityId: any): any => async (
  dispatch: any
) => {
  dispatch({ type: SELECTED_MODALITY, payload: { selectedModalityId } });
};

export const _timerMinutesSecs = (
  timerMinutes: any,
  timerSecs: any
): any => async (dispatch: any) => {
  dispatch({ type: TIMERMINSEC, payload: { timerMinutes, timerSecs } });
};

export const _previewAtbrTimeStamp = (previewAtbrTimeStamp: any): any => async (
  dispatch: any
) => {
  dispatch({ type: PREVIEWATBRTIMESTAMP, payload: { previewAtbrTimeStamp } });
};

export const _updateVitalsCount = (vitalsCount: any): any => async (
  dispatch: any
) => {
  dispatch({ type: UPDATEVITALSCOUNT, payload: { vitalsCount } });
};

export const _enableModalities = (modalityEnable: any, type: any): any => async (
  dispatch: any
) => {
  dispatch({ type: ENABLEMODALITIES, payload: { modalityEnable, type } });
};

export const _selctedDate = (
  selectedDate: any
): any => async (dispatch: any) => {
  dispatch({ type: SELECTEDDATE, payload: { selectedDate } });
};

export const _selectedDocumentSubmissionDetailsId = (
  selectedRowDocumentSubmissionDetailsId: number
): any => async (dispatch: any) => {
  dispatch({
    type: SELECTED_DOUMENT_SUBMISSION_DETAILS_ID,
    payload: { selectedRowDocumentSubmissionDetailsId }
  });
};
export const _selectedDocumentSubmissionDetailsCasePID = (
  selectedRowDocumentSubmissionCasePID: number
): any => async (dispatch: any) => {
  dispatch({
    type: SELECTED_DOUMENT_SUBMISSION_DETAILS_CASE_PID,
    payload: { selectedRowDocumentSubmissionCasePID }
  });
};
export const _setOfflineMode = (isOffline: boolean): any => async (dispatch: any) => {
  dispatch({ type: SET_OFFLINE_MODE, payload: { isOffline } });
};

export const _showOfflineButton = (showOfflineButton: boolean): any => async (dispatch: any) => {
  dispatch({ type: SHOW_OFFLINE_TOGGLE_BUTTON, payload: { showOfflineButton } });
};
export const _selectedActiveTab = (activeTab: string): any => async (dispatch: any) => {
  dispatch({ type: SELECTED_ACTIVE_TAB, payload: { activeTab } });
};


export const _setGlobalSyncLoading = (isLoading: boolean) => ({
  type: SET_GLOBAL_LOADING,
  payload: isLoading,
});

// ** patient forms tab boolean paramter and active tab storing to render them conidtionally **
export const _isPatientFormDetails = (isPatientFormDetails: boolean) => {
  return {
    type: IS_PATIENT_FORM_DETAILS,
    payload: { isPatientFormDetails },
  };
};

export const _setActiveParentTab = (tabName: string) => {
  return {
    type: SET_ACTIVE_PARENT_TAB,
    payload: tabName
  }
};

//** Patient Forms Actions ** //

// request to submit the patient forms to trigger validations
export const _requestPatientFormsSubmit = (value: boolean) => ({
  type: PATIENT_FORMS_SUBMIT_REQUEST,
  payload: {
    submitRequested: value
  }
});

// NEW: clear the above flag after handling
export const _clearPatientFormsSubmitRequest = () => ({
  type: PATIENT_FORMS_SUBMIT_CLEAR,
});

export const _clearPatientFormData = () => ({
  type: CLEAR_PATIENT_FORM_DATA,
});

export const _updatePatientFormField = (fieldKey: string, value: any) => ({
  type: UPDATE_PATIENT_FORM_FIELD,
  payload: { fieldKey, value },
});

export const _setPatientFormData = (formData: Record<string, any>) => ({
  type: SET_PATIENT_FORM_DATA,
  payload: formData,
});
// Action to track validation state
  export const _setPatientFormsValidationErrors = (errors: any) => ({
    type: 'SET_PATIENT_FORMS_VALIDATION_ERRORS',
    payload: errors
  });

  export const _clearPatientFormsValidationErrors = () => ({
    type: 'CLEAR_PATIENT_FORMS_VALIDATION_ERRORS'
  });

  export const _setPatientFormsSaving = (isSaving: any) => ({
    type: 'SET_PATIENT_FORMS_SAVING',
    payload: isSaving
  });
  // New validation thunk
  export const _validatePatientForms = () => {
    return async (dispatch: any, getState: any) => {
      const activeTab = getState().patientInfo.activeTab;
      // Skip validation if not on the Details tab
      if (activeTab !== 'Details') {
        return { isValid: true };
      }
      const formData = getState().patientInfo.patientFormData;
      try {
      // Validate using the schema
      await patientFormsValidationSchema.validate(formData, { abortEarly: false });
      // Clear any previous validation errors
      dispatch(_setPatientFormsValidationErrors({}));

      return {
        isValid: true
      };
    } catch (validationError: any) {
      // Extract and format validation errors
      const errors = {};
      if (validationError.inner) {
        validationError.inner.forEach((error: any) => {
          (errors as Record<string, string>)[error.path] = error.message;
        });
      }
      // Update Redux with validation errors
      dispatch(_setPatientFormsValidationErrors(errors));
      return {
        isValid: false,
        errors
      };
    }
  };
};

export const _triggerPatientFormsRefresh = () => ({
  type: TRIGGER_PATIENT_FORMS_REFRESH
});

// cases: Array<{ id: string, ... }>
export const _setSelectedPrefetchCases = (cases: any) => ({
  type: SET_SELECTED_PREFETCH_CASES,
  payload: cases,
});
export const _removeSelectedPrefetchCase = (casePid: any) => ({
  type: 'REMOVE_SELECTED_PREFETCH_CASE',
  payload: casePid,
});

//** Surgeon Forms Actions ** //
export const _isSurgeonFormDetails = (isSurgeonFormDetails: boolean) => {
  return {
    type: IS_SURGEON_FORM_DETAILS,
    payload: { isSurgeonFormDetails },
  };
};

export const _selectedSurgeonId = (selectedSurgeonId: any) => {
  return {
    type: SELECTED_SURGEON_ID,
    payload: { selectedSurgeonId },
  };
};

export const _selectedSurgeonName = (selectedSurgeonName: any) => {
  return {
    type: SELECTED_SURGEON_NAME,
    payload: { selectedSurgeonName },
  };
};

export const _setSurgeonFormsData = (formData: any) => {
  return {
    type: SET_SURGEON_FORMS_DATA,
    payload: formData,
  };
};

export const _clearSurgeonFormsData = () => {
  return {
    type: CLEAR_SURGEON_FORMS_DATA,
  };
};

export const _updateUnsavedAnestheticInfusion = (data: any) => ({
  type: UPDATE_UNSAVED_ANESTHETIC_INFUSION,
  payload: data,
});

export const _clearUnsavedAnestheticInfusion = () => ({
  type: CLEAR_UNSAVED_ANESTHETIC_INFUSION,
});